import styled from '@emotion/styled';
import SnackbarMUI from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import LinearProgress from '@material-ui/core/LinearProgress';
import Button from '../Button/Button';
import theme from '../../themes/default';

const snackbarMargin = theme.spacing.small;
const marginBetweenButtons = theme.spacing.xxLarge;
// essential adjustments to meet figma requirements
const svgWidthHeight = 20;
const svgPadding = 1;
const svgMinWidthHeight = svgWidthHeight + 2 * svgPadding;
const snackbarWidth = '336px';

export const SnackbarMUIContainer = styled(SnackbarMUI)`
  & .snackbarContentRoot {
    padding: 0;
    max-width: ${snackbarWidth};
  }

  & .snackbarContentRootDark {
    background-color: ${theme.color.designSystem.grey90};

    button {
      color: #d4bbff;
    }
  }

  & .snackbarContentRootLight {
    background-color: ${theme.color.designSystem.grey10};
    color: ${theme.color.black};
  }
`;

export const SnackbarContentWrapper = styled(SnackbarContent)`
  & .snackbarContentClasses {
    padding: 0;
    width: calc(${snackbarWidth} - 2 * ${snackbarMargin});
    margin: ${snackbarMargin};
  }
`;

export const LinearProgressContainer = styled(LinearProgress)`
  margin-bottom: -${snackbarMargin};
  margin-top: ${snackbarMargin};
  margin-left: -${snackbarMargin};
  margin-right: -${snackbarMargin};
  border-radius: 4px;

  > div {
    border-radius: 4px;
  }
`;

export const EmojiIconMessageContainer = styled('div')`
  display: flex;
  align-items: center;
`;

export const ActionRowContainer = styled('div')`
  display: flex;
  justify-content: flex-end;
`;

export const IconContainer = styled('span')`
  align-self: flex-start;
  height: calc(${svgMinWidthHeight}px + 1px);
  min-width: ${svgMinWidthHeight}px;
  min-height: ${svgMinWidthHeight}px;
  margin-right: ${snackbarMargin};

  svg {
    padding: ${svgPadding}px;
    height: ${svgWidthHeight}px;
    width: ${svgWidthHeight}px;
  }
`;

export const EmojiContainer = styled('span')`
  border-radius: 50%;
  margin-right: ${snackbarMargin};
  font-size: ${theme.font.size.headline};
  min-width: calc(${theme.font.size.headline} + 4px);
  text-align: center;
  align-self: flex-start;
`;

export const ActionButton = styled(Button)`
  margin-bottom: -${theme.spacing.xSmall};

  :hover {
    background: none;
    opacity: 0.5;
    transition: opacity 0.15s ease-in;
  }

  &:not(:last-child) {
    margin-right: ${marginBetweenButtons};
  }
`;
